// Malinois Writers isotype — definitive geometry from Manual de marca v2.0.
// 10-polygon faceted dog head, viewBox "15 -15 350 390" (verbatim from the
// official brand manual). Tri-color reversed palette (used on dark surfaces):
// terracota ears + left face facet + chin accent · cream muzzle facets · ink
// inner face (blends into the dark background exactly like the manual print).
// Do NOT alter the polygon points.
export function IsotypeLogo({ className = "h-10", oneColor = false, invert = false }) {
  // Palettes
  const tinta = invert ? "#F0EAE0" : "#14110F";
  const terra = "#B9513B";
  const cream = "#F0EAE0";
  const ink = "#14110F";

  if (oneColor) {
    // One-ink reduction for engraving/embroidery/single-color print.
    return (
      <svg
        viewBox="15 -15 350 390"
        className={className}
        role="img"
        aria-label="Malinois Writers"
      >
        <polygon points="42,251 123,201 123,355" fill={tinta} />
        <polygon points="186,142 280,187 280,250 186,292" fill={tinta} />
        <polygon points="280,187 357,248 280,250" fill={tinta} />
        <polygon points="280,250 357,248 320,270 233,292" fill={tinta} />
        <polygon points="320,270 357,248 344,289 233,292" fill={tinta} />
        <polygon points="123,355 186,292 166,349" fill={tinta} />
        <polygon points="186,292 233,292 166,349" fill={tinta} />
        <polygon points="186,142 123,201 123,355 186,292" fill={tinta} />
        <polygon points="174,0 42,251 186,142" fill={tinta} />
        <polygon points="240,0 186,142 252,176" fill={tinta} />
      </svg>
    );
  }

  // Reversed (invert=true) → exact 7-color palette from the manual (v2.0 approved
  // colorways). The two red shapes are the ears; a deep central facet unites the
  // side-of-head/inner cheek; the muzzle is broken into four cream shades so that
  // the light hits the top-front (highlight) and the sides read as depth planes.
  //   • ears / chin accent : #B9513B (terra bright)
  //   • deep central facet : #8A3A2A (terra deep)
  //   • muzzle mid-tones   : #E4D8C4 · #E0CDA9 · #EAD9B8 (three warm creams)
  //   • highlight planes   : #F4EDDD · #FFFFFF (specular whites)
  if (invert) {
    const T1 = "#B9513B"; // terra bright
    const T2 = "#8A3A2A"; // terra deep
    const C1 = "#E4D8C4"; // warm cream — mid
    const C2 = "#E0CDA9"; // warm cream — darker plane
    const C3 = "#EAD9B8"; // warm cream — softer
    const H1 = "#F4EDDD"; // near-white highlight
    const H2 = "#FFFFFF"; // pure specular
    return (
      <svg
        viewBox="15 -15 350 390"
        className={className}
        role="img"
        aria-label="Malinois Writers"
      >
        {/* Central dark facet — deep terracotta (upper half, below left ear) */}
        <polygon points="42,251 123,201 123,355" fill={T2} />
        {/* Central dark facet — deep terracotta (adjacent side-of-face) */}
        <polygon points="186,142 123,201 123,355 186,292" fill={T2} />
        {/* Top-front of muzzle — bright highlight */}
        <polygon points="186,142 280,187 280,250 186,292" fill={H1} />
        {/* Small specular corner where head meets muzzle — pure white */}
        <polygon points="280,187 357,248 280,250" fill={H2} />
        {/* Nose-bridge / mid-muzzle darker plane */}
        <polygon points="280,250 357,248 320,270 233,292" fill={C2} />
        {/* Nose tip / lower front plane — softer cream */}
        <polygon points="320,270 357,248 344,289 233,292" fill={C3} />
        {/* Chin corner (left) — mid warm cream */}
        <polygon points="123,355 186,292 166,349" fill={C1} />
        {/* Chin accent — bright terracotta */}
        <polygon points="186,292 233,292 166,349" fill={T1} />
        {/* Left ear (long peak) — bright terracotta */}
        <polygon points="174,0 42,251 186,142" fill={T1} />
        {/* Right ear (short peak) — bright terracotta */}
        <polygon points="240,0 186,142 252,176" fill={T1} />
      </svg>
    );
  }

  // Default (on light surfaces) — two-color signature (tinta body, terra accents).
  return (
    <svg
      viewBox="15 -15 350 390"
      className={className}
      role="img"
      aria-label="Malinois Writers"
    >
      {/* Body of the head — tinta */}
      <polygon points="42,251 123,201 123,355" fill={tinta} />
      <polygon points="186,142 280,187 280,250 186,292" fill={tinta} />
      <polygon points="280,187 357,248 280,250" fill={tinta} />
      <polygon points="280,250 357,248 320,270 233,292" fill={tinta} />
      <polygon points="320,270 357,248 344,289 233,292" fill={tinta} />
      <polygon points="123,355 186,292 166,349" fill={tinta} />
      <polygon points="186,142 123,201 123,355 186,292" fill={tinta} />
      {/* Mentón accent — terracota */}
      <polygon points="186,292 233,292 166,349" fill={terra} />
      {/* Ears — terracota */}
      <polygon points="174,0 42,251 186,142" fill={terra} />
      <polygon points="240,0 186,142 252,176" fill={terra} />
    </svg>
  );
}
